import * as React from 'react';
import { AppointmentWizardBody } from './AppointmentWizardBody';
import { DateTime } from 'luxon';
import { Calendar } from 'lucide-react';
import { dateToString } from 'src/utils/utils';
import Link from 'next/link';
import { RouterLinks } from 'src/routing/routerLinks';
import { gql } from '@apollo/client';
import { AppointmentWizardScreenFragment } from './__generated__/AppointmentWizardScreen.generated';
import { AppointmentWizardBodyFragmentDoc } from './__generated__/AppointmentWizardBody.generated';

export interface IAppointmentWizardScreenProps {
  onClose: () => void;
  selectedAppointment: AppointmentWizardScreenFragment | undefined;
  defaultDropoffTime?: DateTime;
}

export const AppointmentWizardScreen: React.FunctionComponent<
  IAppointmentWizardScreenProps
> = props => {
  const requestedOn = props.selectedAppointment?.requestedOn;
  const job = props.selectedAppointment?.job;

  const subtitle = React.useMemo(() => {
    if (!requestedOn) {
      return null;
    }
    let subtitle = `Requested on ${dateToString(new Date(requestedOn))}`;
    let requestedFrom = null;
    switch (props.selectedAppointment?.requestedFrom) {
      case 'web_app':
        requestedFrom = 'web form';
        break;
      case 'voice_agent':
        requestedFrom = 'AI voice agent';
        break;
    }
    if (requestedFrom) {
      subtitle += ` from the ${requestedFrom}`;
    }
    return subtitle;
  }, [requestedOn, props.selectedAppointment?.requestedFrom]);
  return (
    <div className='mb-10 flex w-full gap-5'>
      <div className='m-auto flex w-full max-w-96 flex-col gap-10'>
        <div>
          {job && (
            <Link
              href={`/${RouterLinks.workOrders}/${job.jobMetadata.id}`}
              className='hover:underline'
            >
              <h2 className='text-2xl'>W{job.jobMetadata.jobNumber}</h2>
            </Link>
          )}
          {subtitle && (
            <div className='flex items-center text-sm text-muted-foreground'>
              <Calendar className='mr-2 size-4' />
              <span>{subtitle}</span>
            </div>
          )}
        </div>
        <AppointmentWizardBody
          selectedAppointment={props.selectedAppointment}
          defaultDropoffTime={props.defaultDropoffTime}
          onClose={() => {
            props.onClose();
          }}
        />
      </div>
    </div>
  );
};

const fragment = gql`
  fragment AppointmentWizardScreen on Appointment {
    ...AppointmentWizardBody
  }
  ${AppointmentWizardBodyFragmentDoc}
`;
